import React from "react";
import withContext from "../utils/withContext";
import * as versions from "./version";

export class MainImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adVisible: !versions.isVersionC(props.context.fprVersion),
        };
    }

    setAdVisible() {
        this.setState({ adVisible: false });
    }

    render() {
        const imgUrl = this.props.news.image.replace("/public/media/", "/public/media/491x251/");

        return (
            <div className="main-news-wrap">
                <div className="main-news-wrap__blur" style={{ backgroundImage: `url("${imgUrl}")` }}></div>
                <div className="main-news-wrap__img-wrap">
                    <img className="main-news-img" src={imgUrl} />
                </div>
            </div>
        );
    }
}

export default withContext(MainImage);
